var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-bing",
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0V3.33",
    transform: "translate(120 194.44)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.917,0a6.658,6.658,0,0,0-6.66,6.66v2.1a5.192,5.192,0,0,1-.63,2.28L.357,13.16a2.132,2.132,0,0,0,1.2,3.25,23.34,23.34,0,0,0,14.73,0,2.22,2.22,0,0,0,1.2-3.25l-1.27-2.12a5.23,5.23,0,0,1-.63-2.28V6.66A6.7,6.7,0,0,0,8.917,0Z",
    transform: "translate(111.103 190)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M6.66,0A3.342,3.342,0,0,1,3.33,3.33,3.336,3.336,0,0,1,.98,2.35,3.336,3.336,0,0,1,0,0",
    transform: "translate(116.67 206.82)",
    fill: "none",
    stroke: "#1e1e1e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(123 188)",
    fill: "#01abc1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0a1b0d76f601b022d441aeead00cbce0.svg";
export { ForwardRef as ReactComponent };